var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiDeleteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.556 3.11h-2.89v-.666c0-.858-.697-1.555-1.555-1.555H6.89c-.858 0-1.556.697-1.556 1.555v.667H2.444a.667.667 0 0 0 0 1.333h11.111a.667.667 0 0 0 0-1.333Zm-6.89-.666c0-.122.1-.222.223-.222H9.11c.123 0 .222.1.222.222v.667H6.667v-.667ZM12 5.333H4a.664.664 0 0 0-.666.702l.356 6.76a2.444 2.444 0 0 0 2.44 2.316h3.738c1.3 0 2.373-1.018 2.441-2.316l.356-6.76a.666.666 0 0 0-.666-.702H12Z"
}))));
export default SvgHaidiDeleteIcon;